/**
 * Message type identifiers
 */
export var MessageType;
(function (MessageType) {
    // Client -> Server
    MessageType[MessageType["JOIN_LOBBY"] = 1] = "JOIN_LOBBY";
    MessageType[MessageType["LEAVE_LOBBY"] = 2] = "LEAVE_LOBBY";
    MessageType[MessageType["READY"] = 3] = "READY";
    MessageType[MessageType["INPUT"] = 4] = "INPUT";
    MessageType[MessageType["JOIN_PRACTICE"] = 5] = "JOIN_PRACTICE";
    MessageType[MessageType["JOIN_WINNER_TAKES_ALL"] = 6] = "JOIN_WINNER_TAKES_ALL";
    // Server -> Client
    MessageType[MessageType["LOBBY_STATE"] = 16] = "LOBBY_STATE";
    MessageType[MessageType["PLAYER_JOINED"] = 17] = "PLAYER_JOINED";
    MessageType[MessageType["PLAYER_LEFT"] = 18] = "PLAYER_LEFT";
    MessageType[MessageType["MATCH_START"] = 19] = "MATCH_START";
    MessageType[MessageType["STATE_SNAPSHOT"] = 20] = "STATE_SNAPSHOT";
    MessageType[MessageType["MATCH_END"] = 21] = "MATCH_END";
    // Crypto-related (future)
    MessageType[MessageType["STAKE_REQUEST"] = 32] = "STAKE_REQUEST";
    MessageType[MessageType["STAKE_CONFIRMED"] = 33] = "STAKE_CONFIRMED";
    MessageType[MessageType["REWARD_DISTRIBUTED"] = 34] = "REWARD_DISTRIBUTED";
    // System
    MessageType[MessageType["PING"] = 240] = "PING";
    MessageType[MessageType["PONG"] = 241] = "PONG";
    MessageType[MessageType["ERROR"] = 255] = "ERROR";
})(MessageType || (MessageType = {}));
//# sourceMappingURL=messages.js.map